(
function (skyward, $, undefined)
{
    "use strict";
    skyward.crossReferenceTableEditor = skyward.crossReferenceTableEditor || {};

    skyward.crossReferenceTableEditor.launch = function (args)
    {
        const showPopup = function (jsonResult)
        {
            const columnParser = JSON.parse(args.columnParser);

            const buttons = [
                { text: "Save", click: onSave, icon: "Save", additionalClasses: "crossReferenceTableEditorSaveButton" },
                { text: "Cancel", click: "close", icon: "Cancel" }
            ];

            const popup = skyward.modalLayer.showDialog("Cross Reference Table", jsonResult.html, buttons);
            const crossReferenceTableEditor = popup.content;

            const addButton = crossReferenceTableEditor.find(".addCrossReferenceRow");
            addButton.on("click", addNewCrossReference);

            const deleteRowButton = crossReferenceTableEditor.find(".deleteRow");
            deleteRowButton.on("click", deleteRow);

            const errorContainer = crossReferenceTableEditor.find(".currentRecordContentBaseError");
            const valueIfNotFoundComboBox = crossReferenceTableEditor.find(".crossReferenceValueIfNotFound");

            const templateRow = crossReferenceTableEditor.find(".crossReferenceRowTemplate");
            skyward.events.removeLoadActionClass(templateRow);

            function onSave()
            {
                skyward.validation.clearValidationMessages(crossReferenceTableEditor, errorContainer);

                const crossReferences = getCrossReferences();

                $.ajax({
                    type: "POST",
                    dataType: "JSON",
                    url: skyward.global.virtualDir + "SkySys/Import/ValidateCrossReferenceTable",
                    data: {
                        crossReferencesJson: JSON.stringify(crossReferences),
                        columnParserType: columnParser.Type
                    },
                    success: function (res)
                    {
                        if (res.success)
                        {
                            args.callback(buildCrossReferenceObject(crossReferences));
                            popup.close();
                        }
                        else
                        {
                            skyward.validation.displayValidationMessages({ errors: res.errors }, crossReferenceTableEditor, errorContainer);
                        }
                    }
                });
            };

            function getCrossReferences()
            {
                const crossReference = [];
                crossReferenceTableEditor.find(".crossReferenceRow").not(".crossReferenceRowTemplate").each(function ()
                {
                    const row = $(this);
                    const inputValue = row.find(".crossReferenceInputText").val();
                    const outputValue = row.find(".crossReferenceOutputText").val();

                    if (inputValue || outputValue)
                    {
                        crossReference.push({ Key: inputValue, Value: outputValue });
                    }
                });

                return crossReference;
            }

            function buildCrossReferenceObject(crossReference)
            {
                if ($.isEmptyObject(crossReference))
                {
                    delete columnParser["LookupTable"];
                }
                else
                {
                    columnParser["LookupTable"] = crossReference;
                    columnParser["ValueIfNotFoundOption"] = valueIfNotFoundComboBox.find(".option:selected").val();
                }

                return columnParser;
            }

            function addNewCrossReference()
            {
                const rowCount = templateRow.parent().children().length - 1;
                const newRow = templateRow.clone(true).removeClass("crossReferenceRowTemplate").show();

                newRow.find(".crossReferenceInputText, .crossReferenceOutputText").each(function ()
                {
                    const element = $(this);

                    const currentId = element.prop("id");
                    const newId = `${currentId}-${rowCount}`;
                    element.prop("id", newId);
                    element.attr("data-validate-control-for", newId);

                    const errorLabel = element.siblings();
                    errorLabel.attr("data-validate-message-for", newId);
                });

                templateRow.parent().append(newRow);
                popup.animateModalContents();

                skyward.events.applyLoadActionClass(newRow);
                skyward.window.notifyDOMLoad(newRow);
            }
            
            function deleteRow()
            {
                const row = $(this).parents(".crossReferenceRow");
                row.remove();
                popup.animateModalContents();
            }
        };

        $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/Import/GetCrossReferenceTableEditor",
            type: "POST",
            dataType: "JSON",
            data: {
                columnParser: args.columnParser
            }
        }).done(showPopup);
    };

}(window.skyward = window.skyward || {}, window.jQuery)
);